import { devtools } from 'zustand/middleware';
import { create } from 'zustand';
import { createUserSlice, UserStore } from '@/stores/userStore.ts';
import { createWalletSlice, WalletStore } from './walletStore';
import { createTournamentArenaSlice, TournamentArenaStore } from './tournamentStore';

type TralentStoreProps = UserStore & WalletStore & TournamentArenaStore;

const useTralentStore = create<TralentStoreProps>()(
	devtools((...a) => ({
		...createUserSlice(...a),
		...createWalletSlice(...a),
		...createTournamentArenaSlice(...a),
	})),
);

export default useTralentStore;
